import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = "Signing you in..." }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-hpe-dark-bg via-hpe-dark-surface to-hpe-dark-bg text-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-hpe-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold mb-2">{message}</h2>
        <p className="text-hpe-gray-400">Please wait a moment...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;